(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mivaskin-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mivaskin-testimonials').forEach((section) => {
    const track = section.querySelector('.mivaskin-testimonials__track');
    if (!track) return;
    const cards = Array.from(track.querySelectorAll('.mivaskin-testimonials__card'));
    let index = 0;
    section.querySelectorAll('.mivaskin-testimonials__arrow').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.getAttribute('data-direction') === 'prev' ? -1 : 1;
        index = Math.max(0, Math.min(cards.length - 1, index + direction));
        cards[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
